<template>
 <div>
   <br>
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      controls
      indicators
      background="#ababab"
      img-width="1024"
      img-height="240"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <!-- Text slides with image -->
      <b-carousel-slide
           img-src="img/slide1.jpg"
      ></b-carousel-slide>

      <!-- Slides with custom text -->
      <b-carousel-slide img-src="img/slide2.jpg">
      </b-carousel-slide>

      <!-- Slides with image only -->
      <b-carousel-slide img-src="img/slide3.jpg"></b-carousel-slide>

      <!-- Slides with img slot -->
      <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
      <b-carousel-slide>
        <template v-slot:img>
          <img
            class="d-block img-fluid w-100"
            width="1024"
            height="240"
            src="img/slide2.jpg"
           >
        </template>
      </b-carousel-slide>

      <!-- Slide with blank fluid image to maintain slide aspect ratio -->
     
    </b-carousel>
	<br>	
  
  <div>

    
  <b-card class="text-center">
    <div>
     <h2>Industries</h2>
        <p class="lead">A rotary union is a union that allows for rotation of the united parts. 
        It is thus a device that provides a seal between a stationary supply passage (such as pipe or tubing) 
        and a rotating part (such as a drum, cylinder, or spindle) to permit the flow of a fluid into and 
        out of the rotating part. Fluids typically used with rotary joints and rotating unions include 
        various heat transfer media and fluid power media such as steam, water, thermal oil, hydraulic fluid, 
        and coolants. A rotary union is sometimes referred to as a rotating union, rotary valve, swivel union, 
        rotorseal,rotary couplings, rotary joint, rotating joints, hydraulic coupling, pneumatic rotary union, 
        through bore rotary union, air rotary union, electrical rotary union, or vacuum rotary union</p>
     </div>
  </b-card>
</div>
 
    <br>
<div>
  <div>
    <b-card-group deck>
      <b-card bg-variant="primary" text-variant="white" header="Automotive" class="text-center">
        <b-card-text>  
              Auto manufacturing is a diverse user of rotary unions for a broad range of parts or 
                components and materials, whether machined steel, iron or aluminum, stampings, plastics, 
                glass or paperboard. Rotary unions are used for operations that require coolant, lubricant 
                or hydraulics.</b-card-text>
      </b-card>

      <b-card bg-variant="dark" text-variant="white" header="Agriculture" class="text-center">
        <b-card-text>Equipment used in grain harvesting including combines, tractors, grain carts and threshers 
                employ rotary unions. Once harvested, many crops will be processed with equipment that uses 
                rotary unions. Food processing equipment that use rotary unions include cooling conveyors,
                 flaking mills, shredders, steam cookers, starch dryers, rotary cutters and roll-forming.</b-card-text>
      </b-card>

      <b-card bg-variant="success" text-variant="white" header="Car washes" class="text-center">
        <b-card-text>There are two kinds of car wash facilities that use unions: the automatic and the hand 
                operated. Most manufacturers of automatic systems have several revolving brushes which use 
                55 series to introduce low pressure detergent water through the supporting shaft to the 
                brushes. In addition, automatic car washes have spinners that require rotary unions to 
                transmit high-pressure water into the spinning mechanisms.</b-card-text>
      </b-card>
    </b-card-group>
  </div>
  <div class="mt-3">
    <b-card-group deck>
      <b-card bg-variant="info" text-variant="white" header="Plastics" class="text-center">
        <b-card-text>The manufacturing of plastic materials encompasses a wide variety of applications including
                 cast film, blown film, foam, flexible and rigid sheet extrusion, single and multi-layer 
                 co-extrusion, blow molding, thermoforming, pelletizing, wire and cable, injection molding 
                 and winding. Rotary unions are used for heating or cooling the many processing rolls 
                 throughout the wide variety of applications. In addition, rotary unions for air and 
                 hydraulic service are used in winding and injection molding applications. Many of today’s 
                 modern winding applications will also utilize electrical slip rings.</b-card-text>
      </b-card>

      <b-card bg-variant="warning" text-variant="white" header="Oil and gas" class="text-center">
        <b-card-text>Drilling rigs (oil or gas) use air clutches and brakes that require rotary unions. 
                Water unions are used to flush mud from the drill tip, and must withstand shock and 
                vibration in this severe application. Oil and petrochemical refineries use batch mixers, 
                flaking mills, blenders and drying rolls that each require rotary unions..</b-card-text>
      </b-card>

      <b-card bg-variant="danger" text-variant="white" header="Steel" class="text-center">
        <b-card-text>The steel industry is one of the largest users of rotary unions primarily for continuous 
                casting machines (CCM) which use rotary unions to cool the numerous rolls that support 
                molten slabs as it moves by gravity through various segments onto a run-out table to 
                downstream annealing and heat treating. The slab is formed into coil or sheet. Coil 
                is further converted in processing centers that require hydraulic unions for actuation 
                of mandrels.</b-card-text>
      </b-card>
    </b-card-group>
  </div>

</div>
<br>
<div>
  <b-card class="text-center">
    <div>
     <h2>Our Products</h2>
        <p class="lead">Rotating Unions
            Rotating Unions (also known as rotary swivels, rotary couplings, rotary joints) are precision 
            mechanical devices used to transfer fluid from a stationary source, such as a supply pipe, 
            into a rotating piece of machinery. Rotating Unions are used in numerous manufacturing processes 
            to cool, heat, or transfer fluid (pneumatic or hydraulic) power.</p>
   </div>
  </b-card>
</div>
 <br>
    <div>
  <div>
    <b-card-group deck>
     <b-card class="hvrbox">
      	<img src="img/portfolio/full/item1.png" alt="Mountains" class="hvrbox-layer_bottom">
	<div class="hvrbox-layer_top">
		<b-card-text class="hvrbox-text"><h5><a href="#">Rotating Unions</a></h5>
                <h6>Rotating Unions (also known as rotary swivels, 
                  rotary couplings, rotary joints)</h6></b-card-text>
	</div>
 	          
                 
             
          
	
</b-card> 
   <b-card class="hvrbox">
	<img src="img/portfolio/full/item2.png" alt="Mountains" class="hvrbox-layer_bottom">
	<div class="hvrbox-layer_top">
		<b-card-text class="hvrbox-text">    <h5><a href="#">Slip Rings</a></h5>
                <h6>DEUBLIN Electrical Slip Rings utilize next-generation technology for long-term operation</h6>
           </b-card-text>
	</div>
</b-card>    <b-card class="hvrbox">
	<img src="img/portfolio/full/item3.png" alt="Mountains" class="hvrbox-layer_bottom">
	<div class="hvrbox-layer_top">
		<b-card-text class="hvrbox-text"><h5><a href="#">4 Passages Multi-Purpose </a></h5>
                <h6>4-passage design
Self-supported rotating union
Flanged rotor</h6>
              </b-card-text>
	</div>
</b-card> 
   <b-card class="hvrbox">
	<img src="img/portfolio/full/item4.png" alt="Mountains" class="hvrbox-layer_bottom">
	<div class="hvrbox-layer_top">
		<b-card-text class="hvrbox-text">  <h5><a href="#">Union 1 Passage </a></h5>
                <h6>Monoflow design
Self-supported rotating union
Radial housing connection</h6> 
              </b-card-text>
	</div>
</b-card> 
 
    </b-card-group>
  </div>
  <div class="mt-4">
    <b-card-group deck>
         <b-card class="hvrbox">

 	<img src="img/portfolio/full/item5.png" alt="Mountains" class="hvrbox-layer_bottom">
	<div class="hvrbox-layer_top">
		<b-card-text class="hvrbox-text">  <h5><a href="#">Custom Applications</a></h5>
               <h6>Deublin offers a wide range of Rotating Union models for a wide range of applications. </h6>
              </b-card-text>
	</div>
</b-card> 
   <b-card class="hvrbox">
	<img src="img/portfolio/full/item6.png" alt="Mountains" class="hvrbox-layer_bottom">
	<div class="hvrbox-layer_top">
		<b-card-text class="hvrbox-text">     <h5><a href="#">Water </a></h5>
                <h6>Most common media used for cooling in a variety of applications including printing, plastics, and aluminum casting</h6>
            
              </b-card-text>
	</div>
</b-card> 
   <b-card class="hvrbox">
	<img src="img/portfolio/full/item7.png" alt="Mountains" class="hvrbox-layer_bottom">
	<div class="hvrbox-layer_top">
		<b-card-text class="hvrbox-text">   <h5><a href="#">2620 Series 2-Passages  </a></h5>
                  <h6>Two independent passages for applications such as clamping and unclamping, work piece sensing and cooling</h6>
           </b-card-text>
	</div>
</b-card>    <b-card class="hvrbox">
	<img src="img/portfolio/full/item8.png" alt="Mountains" class="hvrbox-layer_bottom">
	<div class="hvrbox-layer_top">
		<b-card-text class="hvrbox-text">   <h5><a href="#">Air </a></h5>
                <h6>Felt oiler in seal cavity for air service
Oiler for relubrication (3 - 5 drops/month)
Low torque</h6>
           </b-card-text>
	</div>
</b-card> 
    </b-card-group>
  </div>
 
</div>
<br>
<div>
  <b-card>
    <div>
  
      <div class="row">
       

      
        <!--/.col-md-3-->

        <div class="col-md-3 col-sm-6">
          <div class="widget">
            <h3>Our Partners</h3>
            <ul class="list-unstyled">
              <li><a href="#"><h5>Deublin</h5></a></li>
              <li><a href="#"><h5>Barco</h5></a></li>
             
            </ul>
          </div>
        </div>
        <!--/.col-md-3-->
      </div>
    </div>
  
  </b-card>
</div>

   
  </div>
</template>

<script>

export default {
  name: 'home',
  components: {
  
  }
 
    
     
  
}
</script>

<style>


  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  .hvrbox,
.hvrbox * {
	box-sizing: border-box;
}
.hvrbox {
	position: relative;
	display: inline-block;
	overflow: hidden;
	max-width: 100%;
	height: auto;
}
.hvrbox img {
	max-width: 100%;
}
.hvrbox .hvrbox-layer_bottom {
	display: block;
}
.hvrbox .hvrbox-layer_top {
	opacity: 0;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.6);
	color: #fff;
	padding: 0px;
	-moz-transition: all 0.4s ease-in-out 0s;
	-webkit-transition: all 0.4s ease-in-out 0s;
	-ms-transition: all 0.4s ease-in-out 0s;
	transition: all 0.4s ease-in-out 0s;
}
.hvrbox:hover .hvrbox-layer_top,
.hvrbox.active .hvrbox-layer_top {
	opacity: 1;
}
.hvrbox .hvrbox-text {
	text-align: center;
	font-size: 14px;
	display: inline-block;
	position: absolute;
	top: 50%;
	left: 50%;
	-moz-transform: translate(-50%, -50%);
	-webkit-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
}
.hvrbox .hvrbox-text_mobile {
	font-size: 15px;
	border-top: 1px solid rgb(179, 179, 179); /* for old browsers */
	border-top: 1px solid rgba(179, 179, 179, 0.7);
	margin-top: 5px;
	padding-top: 2px;
	display: none;
}
.hvrbox.active .hvrbox-text_mobile {
	display: block;
}
</style>
